var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSilo = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3583 13.0983C28.455 5.64583 22.1317 0 14.6792 0C10.84 0 7.00083 1.58083 4.29083 4.29083C1.58083 7.00083 0 10.84 0 14.6792V45.1667H29.3583V17.615L36.1333 21.68V45.1667H40.65V24.39L45.1667 27.1V22.5833L29.3583 13.0983ZM20.325 40.65H9.03333V36.1333H20.325V40.65ZM20.325 31.6167H9.03333V27.1H20.325V31.6167ZM20.325 22.5833H9.03333V18.0667H20.325V22.5833ZM5.19417 11.2917C6.54917 7.22667 10.3883 4.51667 14.6792 4.51667C18.97 4.51667 22.8092 7.22667 24.1642 11.2917H5.19417Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSilo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Silo.31129a3bdb9b06d3be9fc6c68b5f0377.svg";